module.exports = __webpack_public_path__ + "img/banner_generic_top.bc16bfdd.jpg";